import { editPrescriptionApi, removePrescriptionApi, getOutpatientDetailApi, saveDoorApi } from "@/api/outpatientDetail.js";
import { checkEffect, getRecipeContinue, picToRecipe, examineContinueNoPass, examineContinuePass, deleteType, resetSort, recipeResetSort, projectCopyApi, savePrecreiptionImg, getPrecreiptionImg } from '@/api/prescription'
class prescriptionDTO {

    /**
     * 编辑处方
     */
    static editPrescription(obj) {
            return new Promise((resolve, reject) => {
                editPrescriptionApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //删除处方
    static removePrescription(obj) {
            return new Promise((resolve, reject) => {
                removePrescriptionApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        // 查询处方信息
    static getOutpatientDetailApi(obj) {
            return new Promise((resolve, reject) => {
                getOutpatientDetailApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        // 处方相反相畏校验
    static checkEffect(obj) {
            return new Promise((resolve, reject) => {
                checkEffect(obj).then(res => {
                    resolve(res)
                })
            })
        }
        // 处方相反相畏校验
    static checkEffect(obj) {
            return new Promise((resolve, reject) => {
                checkEffect(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //获取续方信息
    static getRecipeContinue(obj) {
            return new Promise((resolve, reject) => {
                getRecipeContinue(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //图片转录
    static picToRecipe(obj) {
            return new Promise((resolve, reject) => {
                picToRecipe(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //拒接审方
    static examineContinueNoPass(obj) {
            return new Promise((resolve, reject) => {
                examineContinueNoPass(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //通过审方
    static examineContinuePass(obj) {
            return new Promise((resolve, reject) => {
                examineContinuePass(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //删除处方模板类型
    static deleteType(obj) {
            return new Promise((resolve, reject) => {
                deleteType(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //重置处方类型排序
    static resetSort(obj) {
            return new Promise((resolve, reject) => {
                resetSort(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //重置处方排序
    static recipeResetSort(obj) {
            return new Promise((resolve, reject) => {
                recipeResetSort(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //保存整个处方
    static saveDoorDTO(obj) {
            return new Promise((resolve, reject) => {
                saveDoorApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //复制单个处方
    static projectCopyDTO(obj) {
            return new Promise((resolve, reject) => {
                projectCopyApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //保存处方图片
    static savePrecreiptionImg(obj) {
            return new Promise((resolve, reject) => {
                savePrecreiptionImg(obj).then(res => {
                    resolve(res)
                })
            })
        }
        //获取处方图片
    static getPrecreiptionImg(obj) {
        return new Promise((resolve, reject) => {
            getPrecreiptionImg(obj).then(res => {
                resolve(res)
            })
        })
    }

}
export { prescriptionDTO }